'use client';

import React from 'react';

export default function GetDetailsPart({
                                           determinant,
                                           details,
                                           characterAmount,
                                           showHeading,
                                           stripTags = false
                                       }) {
    for (const item of details) {
        if (item.type === determinant) {
            let text = item.text;

            if (!showHeading) {
                text = text.replace(/<h4.*>.*?<\/h4>/ig, '');
            }

            const charCount = parseInt(characterAmount, 10);
            if (charCount > 0) {
                text = text.substring(0, charCount) + '...';
            }

            if (stripTags) {
                text = text.replace(/(<([^>]+)>)/ig, '');
            }

            return (
                <div key={item.id}>
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                </div>
            );
        }
    }

    return null;
}
